import $ from 'jquery';
import get from 'lodash/get';

const SELECTORS = {
  TOGGLE_CONTAINER: '.js-toggle-container',
  TOGGLE_DROPDOWN: '.js-toggle-dropdown'
};

export default function(){
  const categoryHeader = get(window, 'rcProps.trigger.plp.categoryHeader', false);
  if (categoryHeader === true || categoryHeader === 'true') {
    const $categoryDropdown = $(SELECTORS.TOGGLE_CONTAINER).find(SELECTORS.TOGGLE_DROPDOWN);

    if ($categoryDropdown.length) {
      $categoryDropdown.click();
    }
  }
};



// WEBPACK FOOTER //
// ./src/scripts/entry-points/plp/amp-category-menu.js